module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_2-1f4c681a4cf7cc51fdc9a18b2f4ada2f.png";